import React, { useEffect, useState } from "react";
import { Button, Dialog, EditIcon, PlusIcon, TrashIcon } from "evergreen-ui";
import { Table, Card, Form, Input, message } from "antd";
import FireFetch from "../../../Firebase/FireFetch";
import { TableExport } from "tableexport";
import Firebase from "../../../Firebase/Firebase";
import { invalidateDemoData, useListVals } from "../../../Firebase/databaseHooks";
import { getDatabase, ref, update } from "firebase/database";
import TableActionMenu from "../../../Common/TableActionMenu";

var db = getDatabase(Firebase);
const CountriesLayout = (props) => {
	const canCreate = props.canCreate !== false;
	const canUpdate = props.canUpdate !== false;
	const canDelete = props.canDelete !== false;
	const columns = [
		{
			title: 'Country',
			dataIndex: 'country',
			key: 'country',
			sorter: (a, b) => a.country && a.country.localeCompare(b.country),
		},
		{
			title: 'Code',
			dataIndex: 'code',
			key: 'code',
			sorter: (a, b) => a.code && a.code.localeCompare(b.code),
		},
		{
			title: 'Action',
			dataIndex: 'action',
			key: 'action',
		}
	]
	const [countriesArray, setCountriesArray] = useState([]);
	const [arrayIn, loading] = useListVals(ref(db, "talmidsdb/countries"));
	const [editCountry, setEditCountry] = useState(null);
	const [showEditModal, setShowEditModal] = useState(false);

	useEffect(() => {
		//setCountriesArray(props.countries);
		var tempArray = [];
		if (arrayIn) {
			arrayIn.map((item, index) => {
				tempArray.push({
					key: index,
					country: item.countryName,
					code: item.alpha3Code,
					action: (
						<TableActionMenu
							items={[
								canUpdate && {
									key: "edit",
									label: "Edit",
									onClick: () => {
										setEditCountry(item);
										setShowEditModal(true);
									},
								},
								canDelete && {
									key: "delete",
									label: "Delete",
									danger: true,
									onClick: () => {
										if (confirm("Delete this country?")) {
											props.messageBack("countries", "delete", item.id);
										}
									},
								},
							]}
						/>
					)

				})
			});
			setCountriesArray(tempArray);
		}
	}, [arrayIn, props, canUpdate, canDelete]);

	console.log(editCountry);

	const handleEdit = (values) => {
		if (!canUpdate) {
			message.error("You do not have permission to update countries.");
			return;
		}

		const payload = {
			alpha3Code: values.alpha3Code.toUpperCase(),
			countryName: values.country,
			count: 0,
			capital: values.capital
		};

		update(ref(db, "talmidsdb/countries/" + editCountry.id), payload).then(() => {
			invalidateDemoData([
				"talmidsdb/countries",
				"talmidsdb/countries/" + editCountry.id,
			]);
			message.success("Country Updated");
			setShowEditModal(false);
		})
			.catch((error) => {
				message.error("Unable to update : " + error);
			})
	}

	return (
		<div className="font-Nunito">
			<Dialog title="Edit Modal"
				isShown={showEditModal}
				topOffset="10px"
				hasFooter={false}
				onCloseComplete={() => { setShowEditModal(false) }}>
				<Form
					layout="vertical"
					onFinish={handleEdit}
					initialValues={{
						country: editCountry && editCountry.countryName,
						alpha3Code: editCountry && editCountry.alpha3Code,
						capital: editCountry && editCountry.capital
					}}
				>
					<Form.Item label="Enter country name"
						name="country"
						rules={[{ required: true }]}
						className="d-flex flex-column my-2 mt-3">
						<Input
							className="w-100"
							name="text-input-name"
							placeholder="enter country name"
						/>
					</Form.Item>
					<Form.Item label="Enter Country's 3 letter alpha Code"
						name="alpha3Code"
						rules={[{ required: true },
						{ max: 3, message: 'code must be maximum 3 characters' },
						{
							pattern: new RegExp(/^[A-Z]+$/i),
							message: "field does not accept numbers or special characters"
						}]}
						className="d-flex flex-column my-2 mt-3">
						<Input
							className="w-100"
							name="text-input-name"
							placeholder="enter country code"
						/>
					</Form.Item>

					<Form.Item label="Enter country capital"
						name="capital"
						className="d-flex flex-column my-2">
						<Input
							className="w-100"
							name="text-input-name"
							placeholder="enter capital"
						/>
					</Form.Item >
					<Button appearance="primary" htmlType="submit" className="mt-2">Edit</Button>
				</Form>
			</Dialog>
			<div>
				{canCreate && (
					<Button appearance="primary" className="ml-3 my-2" onClick={() => {
						props.messageBack("countries", "create");
					}}>
						New Country <PlusIcon />
					</Button>
				)}
				<Button appearance="primary" className="mx-2" onClick={() => {
					FireFetch.exportXL(TableExport(document.getElementById("dataTable"), {
						filename: "Countries",
						exportButtons: false,
						sheetname: "Countries",
					}), countriesArray);
				}}>
					Print
				</Button>
			</div>
			<Card className="d-flex flex-column">
				<div>
					<Table style={{ overflow: "auto" }}
						pagination={{ defaultPageSize: 100, showSizeChanger: true, pageSizeOptions: ['20', '50', '100'] }}
						id={"dataTable"} dataSource={countriesArray} columns={columns} loading={loading} />
				</div>
			</Card>
		</div>

	);
}

export default CountriesLayout;
